"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RequiredMinimumDistributionPageOne;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _RequiredMinimumDistributionFormControls = require("./RequiredMinimumDistributionFormControls");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _RequiredMinimumDistributionWizardCalc = require("./RequiredMinimumDistributionWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RequiredMinimumDistributionPageOne() {
  var {
    values: {
      birthMonth,
      birthDay,
      birthYear,
      beneficiary,
      spouseBirthDay,
      spouseBirthMonth,
      spouseBirthYear,
      accountBalance
    },
    errors,
    touched,
    values,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionFormControls.BirthDay, {
    errors: errors,
    touched: touched,
    birthDay: birthDay,
    birthMonth: birthMonth,
    birthYear: birthYear,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError
  }), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionFormControls.Beneficiary, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), !scenarioSpouseNotBeneficiary(beneficiary) ? /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionFormControls.SpouseBirthDay, {
    errors: errors,
    touched: touched,
    spouseBirthDay: spouseBirthDay,
    spouseBirthMonth: spouseBirthMonth,
    spouseBirthYear: spouseBirthYear,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError
  }) : null, "\xA0My retirement account balance\xA0", /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'retirementAccount',
    text: _RequiredMinimumDistributionWizardCalc.popoverConfig.retirementAccountBalanceInfo
  }), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionFormControls.AccountBalance, {
    errors: errors,
    touched: touched,
    values: values,
    accountBalance: accountBalance,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RequiredMinimumDistributionFormControls.RateOfReturn, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }));
}
function scenarioSpouseNotBeneficiary(beneficiary) {
  return beneficiary == 'not my spouse';
}